<template>
  <QStepper
    v-on="$listeners"
    v-bind="$attrs"
    :swipeable="swipeable"
    :animated="animated"
    :class="['sai-stepper', { 'hide-header': hideHeader }]"
  >
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"></slot>
    </template>
  </QStepper>
</template>

<script>
import { QStepper } from 'quasar';

export default {
  name: 'SAIStepper',
  props: {
    hideHeader: {
      type: Boolean,
      default: true
    },
    swipeable: {
      type: Boolean,
      default: true
    },
    animated: {
      type: Boolean,
      default: true
    }
  },
  components: {
    QStepper
  }
};
</script>

<style lang="sass" scoped>
.sai-stepper::v-deep
  &.hide-header
    .q-stepper__header
      display: none

  .q-stepper__content
    flex: 1 0
</style>
